import './assets/scss/app.scss';
import './assets/js/app';


// WEBPACK FOOTER //
// ./ui/w-theme-child.entrypoint.js